import { Breadcrumb } from "@refinedev/mui";
import { Box } from "@mui/material";
import PageHeading from "../../components/pageHeading";
export const CYRCSTEMComputersTrainingSessionsConducted = () => {
  return (
    <Box>
      <Breadcrumb />
      <PageHeading heading="Training sessions conducted" />
    </Box>
  );
};
